<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container quotation-container">
      <div class="loading-over" v-if="this.turn_to_pdf==true">
        <div class="loading-content">
          <img src="../../assets/img/loading.gif" style="height:200px">
          <h4><b>轉存PDF中，請稍候～</b></h4>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="material-table-widget dashboard_top_bar" v-if="isPresent(quotation)">
              <button class="btn btn-default primary-btn" @click="GoDeal(quotation.deal_token)"><i class="glyphicon glyphicon-circle-arrow-left"></i> 返回</button>
              <a class="btn btn-default primary-btn" v-bind:href=" axios.defaults.baseURL +'/pdf_generators/quotation.html?quotation_token='+ quotation.quotation_token" target="_blank"><i class="fa fa-search"></i> 預覽</a>
              <a class="btn btn-default primary-btn" v-bind:href=" axios.defaults.baseURL +'/pdf_generators/quotation.pdf?quotation_token='+ quotation.quotation_token + '&v=' + Math.random()" target="_blank"><i class="fa fa-search"></i> 預覽PDF</a>
              <button class="btn btn-default primary-btn pull-right" @click="turnToPdf()"><i class="fa fa-lock"></i> 完成報價單，及轉存PDF</button>
              <button class="btn btn-default primary-btn pull-right mr10" @click="SettingModal=true;"><i class="fa fa-cog"></i></button>
              <button class="btn btn-default primary-btn pull-right mr10" @click="syncQuotationAll()"><i class="fa fa-save"></i></button>
              <span class="pull-right save-time mr10" v-if="updating==false">自動儲存：{{ quotation.updated_at | moment("YYYY-MM-DD, h:mm:ss a")}}</span>
              <span class="pull-right save-time mr10" v-else>自動儲存中....</span>
            </div>
            <div class="quotation" v-if="isPresent(quotation)">
              <div class="quotation-header">
                <div class="company_info text-left">
                  <img v-if="quotation.logo==''" class="pointer" src="/static/logo-default.jpg" @click="SettingModal=true">
                  <img v-else class="pointer" :src="quotation.logo" @click="SettingModal=true">
                  <h2 style="margin:0px;">
                    <!-- 公司名稱編輯區 -->
                    <span class="pointer" v-if="quotation.edit=='no' || quotation.edit!='sales_information_company_name'"  @click="editTextClick('sales_information_company_name',quotation.sales_information.company_name)">
                      <i class="fa fa-pencil-alt"></i> 
                      <b v-if="checkEmpty(quotation.sales_information.company_name)">本公司名稱</b>
                      <b v-else> {{quotation.sales_information.company_name}}</b>
                    </span>
                    <input ref="sales_information_company_name" class="full-input" v-if="quotation.edit=='sales_information_company_name'" v-model="content_cache" v-on:blur="quotation.edit='no'; quotation.sales_information.company_name=content_cache; UpdateQuotation()" @keydown.enter="$event.target.blur()">
                  </h2>
                </div>
                <div class="quotation_info">
                  <table class="table text-center table-bordered">
                    <thead>
                      <tr>
                        <th class="text-center">報價日期</th>
                        <th class="text-center">報價編號</th>
                        <th class="text-center">回簽日期</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <!-- 報價日期編輯區 -->
                          <span class="pointer" v-show="quotation.edit=='no' || quotation.edit!='quotation_information_date'"  @click="editTextClick('quotation_information_date',quotation.quotation_information.date)">
                            <i class="fa fa-pencil-alt"></i> 
                            <span v-if="checkEmpty(quotation.quotation_information.date)">報價日期</span>
                            <span v-else> {{quotation.quotation_information.date}}</span>
                          </span>
                          <input ref="quotation_information_date" class="full-input" v-show="quotation.edit=='quotation_information_date'" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation.quotation_information.date=content_cache; UpdateQuotation()" >
                        </td>
                        <td>
                          <!-- 報價單編號編輯區 -->
                          <span class="pointer" v-show="quotation.edit=='no' || quotation.edit!='quotation_information_number'"  @click="editTextClick('quotation_information_number',quotation.quotation_information.number)">
                            <i class="fa fa-pencil-alt"></i> 
                            <span v-if="checkEmpty(quotation.quotation_information.number)">報價單號</span>
                            <span v-else> {{quotation.quotation_information.number}}</span>
                          </span>
                          <input ref="quotation_information_number" class="full-input" v-show="quotation.edit=='quotation_information_number'" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation.quotation_information.number=content_cache; UpdateQuotation()">
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="clear-both"></div>
                <div class="client_info text-left">
                  <div class="header">
                    <b>客戶資訊</b>
                  </div>
                  <div class="content">
                    <p class="pointer">
                      <!-- 客戶姓名編輯區 -->
                      <span class="pointer" v-show="quotation.edit=='no' || quotation.edit!='client_information_name'"  @click="editTextClick('client_information_name',quotation.client_information.name)">
                        <i class="fa fa-pencil-alt"></i> 
                        <span v-if="checkEmpty(quotation.client_information.name)">客戶姓名</span>
                        <span v-else> {{quotation.client_information.name}}</span>
                      </span>
                      <input ref="client_information_name" class="medium-input" v-show="quotation.edit=='client_information_name'" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation.client_information.name=content_cache; UpdateQuotation()">
                      <span class="pointer" v-show="quotation.edit=='no' || quotation.edit!='client_information_phone'"  @click="editTextClick('client_information_phone',quotation.client_information.phone)">
                        <i class="fa fa-pencil-alt"></i> 
                        <span v-if="checkEmpty(quotation.client_information.phone)">客戶電話</span>
                        <span v-else> {{quotation.client_information.phone}}</span>
                      </span>
                      <input ref="client_information_phone" class="medium-input" v-show="quotation.edit=='client_information_phone'" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation.client_information.phone=content_cache; UpdateQuotation()">
                    </p>
                    <p class="pointer">
                      <!-- 客戶Email編輯區 -->
                      <span class="pointer" v-show="quotation.edit=='no' || quotation.edit!='client_information_email'"  @click="editTextClick('client_information_email',quotation.client_information.email)">
                        <i class="fa fa-pencil-alt"></i> 
                        <span v-if="checkEmpty(quotation.client_information.email)">客戶Email</span>
                        <span v-else> {{quotation.client_information.email}}</span>
                      </span>
                      <input ref="client_information_email" class="medium-input" v-show="quotation.edit=='client_information_email'" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation.client_information.email=content_cache; UpdateQuotation()">
                    </p>
                    <p class="pointer">
                      <!-- 客戶公司名編輯區 -->
                      <span class="pointer" v-if="quotation.edit=='no' || quotation.edit!='client_information_company_name'"  @click="editTextClick('client_information_company_name',quotation.client_information.company_name)">
                        <i class="fa fa-pencil-alt"></i> 
                        <span v-if="checkEmpty(quotation.client_information.company_name)">客戶公司全名</span>
                        <span v-else> {{quotation.client_information.company_name}}</span>
                      </span>
                      <input ref="client_information_company_name" class="medium-input" v-show="quotation.edit=='client_information_company_name'" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation.client_information.company_name=content_cache; UpdateQuotation()">
                    </p>
                    <p class="pointer">
                      <!-- 客戶公司地址編輯區 -->
                      <span class="pointer" v-if="quotation.edit=='no' || quotation.edit!='client_information_address'"  @click="editTextClick('client_information_address',quotation.client_information.address)">
                        <i class="fa fa-pencil-alt"></i> 
                        <span v-if="checkEmpty(quotation.client_information.address)">客戶公司地址</span>
                        <span v-else> {{quotation.client_information.address}}</span>
                      </span>
                      <input ref="client_information_address" class="medium-input" v-show="quotation.edit=='client_information_address'" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation.client_information.address=content_cache; UpdateQuotation()">
                    </p>
                  </div>
                </div>
                <div class="sales_info">
                  <div class="header">
                    <b>業務資訊</b>
                  </div>
                  <div class="content">
                    <p>
                      <!-- 姓名編輯區 -->
                      <span class="pointer" v-show="quotation.edit=='no' || quotation.edit!='sales_information_name'"  @click="editTextClick('sales_information_name',quotation.sales_information.name)">
                        <i class="fa fa-pencil-alt"></i> 
                        <span v-if="checkEmpty(quotation.sales_information.name)">業務姓名</span>
                        <span v-else> {{quotation.sales_information.name}}</span>
                      </span>
                      <input ref="sales_information_name" class="medium-input" v-show="quotation.edit=='sales_information_name'" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation.sales_information.name=content_cache; UpdateQuotation()">
                      <!-- 職位編輯區 -->
                      <span class="pointer" v-show="quotation.edit=='no' || quotation.edit!='sales_information_position'"  @click="editTextClick('sales_information_position',quotation.sales_information.position)">
                        <i class="fa fa-pencil-alt"></i> 
                        <span v-if="checkEmpty(quotation.sales_information.position)">職位</span>
                        <span v-else> {{quotation.sales_information.position}}</span>
                      </span>
                      <input ref="sales_information_position" class="medium-input" v-show="quotation.edit=='sales_information_position'" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation.sales_information.position=content_cache; UpdateQuotation()">
                      <!-- Phone編輯區 -->
                      <span class="pointer" v-show="quotation.edit=='no' || quotation.edit!='sales_information_phone'"  @click="editTextClick('sales_information_phone',quotation.sales_information.phone)">
                        <i class="fa fa-pencil-alt"></i> 
                        <span v-if="checkEmpty(quotation.sales_information.phone)">聯絡電話</span>
                        <span v-else> {{quotation.sales_information.phone}}</span>
                      </span>
                      <input ref="sales_information_phone" class="medium-input" v-show="quotation.edit=='sales_information_phone'" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation.sales_information.phone=content_cache; UpdateQuotation()">
                    </p>
                    <p>
                      <!-- Email編輯區 -->
                      <span class="pointer" v-show="quotation.edit=='no' || quotation.edit!='sales_information_email'"  @click="editTextClick('sales_information_email',quotation.sales_information.email)">
                        <i class="fa fa-pencil-alt"></i> 
                        <span v-if="checkEmpty(quotation.sales_information.email)">Email</span>
                        <span v-else> {{quotation.sales_information.email}}</span>
                      </span>
                      <input ref="sales_information_email" class="full-input" v-show="quotation.edit=='sales_information_email'" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation.sales_information.email=content_cache; UpdateQuotation()">
                    </p>
                    <p>
                      <!-- 公司統編編輯區 -->
                      <span class="pointer" v-show="quotation.edit=='no' || quotation.edit!='sales_information_company_number'"  @click="editTextClick('sales_information_company_number',quotation.sales_information.company_number)">
                        <i class="fa fa-pencil-alt"></i> 
                        <span v-if="checkEmpty(quotation.sales_information.company_number)">統一編號：無</span>
                        <span v-else>統一編號：{{quotation.sales_information.company_number}}</span>
                      </span>
                      <input ref="sales_information_company_number" class="medium-input" v-show="quotation.edit=='sales_information_company_number'" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation.sales_information.company_number=content_cache; UpdateQuotation()">
                    </p>
                    <p>
                      <!-- 地址編輯區 -->
                      <span class="pointer" v-show="quotation.edit=='no' || quotation.edit!='sales_information_address'"  @click="editTextClick('sales_information_address',quotation.sales_information.address)">
                        <i class="fa fa-pencil-alt"></i> 
                        <span v-if="checkEmpty(quotation.sales_information.address)">公司地址</span>
                        <span v-else> {{quotation.sales_information.address}}</span>
                      </span>
                      <input ref="sales_information_address" class="full-input" v-show="quotation.edit=='sales_information_address'" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation.sales_information.address=content_cache; UpdateQuotation()">
                    </p>
                  </div>
                </div>
                <div class="clear-both"></div>
              </div>
              <div class="quotation-content">
                <h4 class="quotation-title">
                  <!-- 報價單標題編輯區 -->
                  <span class="pointer" v-show="quotation.edit=='no' || quotation.edit!='quotation_information_title'"  @click="editTextClick('quotation_information_title',quotation.quotation_information.title)">
                    <i class="fa fa-pencil-alt"></i> 
                    <span v-if="checkEmpty(quotation.quotation_information.title)">報價單標題</span>
                    <span v-else> {{quotation.quotation_information.title}}</span>
                  </span>
                 
                  <input ref="quotation_information_title" class="xlarge-input" v-show="quotation.edit=='quotation_information_title'" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation.quotation_information.title=content_cache; UpdateQuotation()">
                </h4>
                <button v-if="quotation.quotation_information.hide_subtotal==true"  @click="quotation.quotation_information.hide_subtotal=false;syncQuotationAll()" class="btn btn-xs btn-default select_show_subtotal "><i class="fa fa-eye-slash"></i> 單價總價不顯示</button>
                <button v-else  @click="quotation.quotation_information.hide_subtotal=true;syncQuotationAll()" class="btn btn-xs btn-default select_show_subtotal active"><i class="fa fa-eye"></i> 單價總價顯示</button>
                <table class="quotation-table table" style="margin-bottom:0px;" v-bind:class="{'HideAllSubTotal': quotation.quotation_information.hide_subtotal }">
                  <thead>
                    <tr  v-bind:style="{'background-color': quotation['quotation_information']['background_color1'].hex,'color':quotation['quotation_information']['color1'].hex,}">
                      <th class="quotation_column1">#</th>
                      <th class="quotation_column2">項目</th>
                      <th class="quotation_column3">內容</th>
                      <th class="quotation_column4">數量</th>
                      <th class="quotation_column5">單價</th>
                      <th class="quotation_column6" style="border-right:none !important">總價</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="6" style="padding:0px">
                        <div class="intro" v-if="quotation.quotation_item_categories.length == 0">
                          <h3>沒有品項或分類，請從右側的項目區域，點擊加入新品項</h3>
                        </div>
                        <Container
		                      @drop="onListDrop($event)"
		                      lock-axis="y"
		                      :drop-placeholder="dropPlaceholderOptions"
		                    >
                    			<Draggable class="item-lists" v-for="quotation_item_category,indexPc in quotation.quotation_item_categories" :key="quotation_item_category.id" style="overflow:initial">
	                          <div class="draggable_quotation_item_cateogry">
	                            <p class="pointer  mb0" v-show="quotation.edit=='no' || quotation.edit!=('quotation_item_category_name'+quotation_item_category.id)"  @click="editTextClick(('quotation_item_category_name'+quotation_item_category.id),quotation_item_category.name)">
	                              <i class="fa fa-pencil-alt"></i> 
	                              <span v-if="checkEmpty(quotation_item_category.name)">分類名稱</span>
	                              <span v-else>{{quotation_item_category.name}}</span>
	                            </p>
	                            <input tyle="number" v-bind:ref="('quotation_item_category_name'+quotation_item_category.id)" class="large-input" v-show="quotation.edit==('quotation_item_category_name'+quotation_item_category.id)" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation_item_category.name=content_cache;quotation_item_category.product_category_id=''; UpdateCategory(quotation_item_category)">
	                            <div class="button-area">
	                              <a class="row-edit pull-right" @click="delete_quotation_item_category=quotation_item_category;checkQuotationItemCategoryBeforeDelete(quotation_item_category)"><span class="zmdi zmdi-close"></span></a>
	                            </div>
	                          </div>
	                          <div class="dragArea full-width text-left ">
		                          <Container
		                            group-name="item"
		                            @drop="(e) => onItemDrop(quotation_item_category.id, e)"
		                            :get-child-payload="getCardPayload(quotation_item_category.id)"
		                            lock-axis="y"
		                            :drop-placeholder="dropItemPlaceholderOptions"
		                            class="quotation_item_drag_area container-fluid move-pointer"

		                          >
		                            <Draggable class="draggable_quotation_item row" style="display:flex;overflow:initial" v-for="quotation_item,index in quotation_item_category.quotation_items" :key="quotation_item.id">
	                                <div class="quotation_column1">
	                                  {{index+1}}
	                                </div>
	                                <div class="quotation_column2">
	                                  <p class="pointer mb0" v-show="quotation.edit=='no' || quotation.edit!=('quotation_item_name'+quotation_item.id)"  @click="editTextClick(('quotation_item_name'+quotation_item.id),quotation_item.name)">
	                                    <i class="fa fa-pencil-alt"></i> 
	                                    <span v-if="checkEmpty(quotation_item.name)"></span>
	                                    <span v-else> {{quotation_item.name}}</span>
	                                  </p>
	                                  <input v-bind:ref="('quotation_item_name'+quotation_item.id)" class="full-input" v-show="quotation.edit==('quotation_item_name'+quotation_item.id)" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation_item.name=content_cache; updateQuotationItem(quotation_item)">
	                                </div>
	                                <div class="quotation_column3">
	                                  <div v-show="quotation.edit=='no' || quotation.edit!=('quotation_item_description'+quotation_item.id)"  @click="editTextClick(('quotation_item_description'+quotation_item.id),quotation_item.description)" v-if="quotation_item.description==null || quotation_item.description==''" class="pointer">
	                                    <i class="fa fa-pencil-alt"></i> 
	                                  </div>
	                                  <div v-show="quotation.edit=='no' || quotation.edit!=('quotation_item_description'+quotation_item.id)"   @click="editTextClick(('quotation_item_description'+quotation_item.id),quotation_item.description);" v-else  class="pointer"><pre class="pre-style"><i class="fa fa-pencil-alt"></i> {{quotation_item.description}}</pre>

	                                  </div>
	                                  <textarea v-autosize="quotation_item.description" v-bind:ref="('quotation_item_description'+quotation_item.id)" class="full-input" rows=3 v-show="quotation.edit==('quotation_item_description'+quotation_item.id)" v-model="content_cache" v-on:blur="quotation.edit='no';quotation.edit='no'; quotation_item.description=content_cache; updateQuotationItem(quotation_item)">{{quotation_item.description}}</textarea>
	                                </div>
	                                <div class="quotation_column4">
	                                  <p class="pointer mb0" v-show="quotation.edit=='no' || quotation.edit!=('quotation_item_number'+quotation_item.id)"  @click="editTextClick(('quotation_item_number'+quotation_item.id),quotation_item.number)">
	                                    <i class="fa fa-pencil-alt"></i> 
	                                    <span v-if="checkEmpty(quotation_item.number)">0</span>
	                                    <span v-else> {{quotation_item.number}}</span>
	                                  </p>
	                                  <input type="number" @keypress="isNumber($event)" v-bind:ref="('quotation_item_number'+quotation_item.id)" class="full-input" v-show="quotation.edit==('quotation_item_number'+quotation_item.id)" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation_item.number=content_cache; updateQuotationItem(quotation_item)">
	                                </div>
	                                <div class="quotation_column5 hideIfNoShow">
	                                  <p class="pointer mb0" v-show="quotation.edit=='no' || quotation.edit!=('quotation_item_price'+quotation_item.id)"  @click="editTextClick(('quotation_item_price'+quotation_item.id),quotation_item.price);changePriceDefault()">
	                                    <i class="fa fa-pencil-alt"></i> 
	                                    <span v-if="checkEmpty(quotation_item.price)">0</span>
	                                    <span v-else>$ {{quotation_item.price.toLocaleString()}}</span>
	                                  </p>
	                                  <input type="number" @keypress="isNumber($event)" v-bind:ref="('quotation_item_price'+quotation_item.id)" class="full-input" v-show="quotation.edit==('quotation_item_price'+quotation_item.id)" v-model="content_cache" @keydown.enter="$event.target.blur()" v-on:blur="quotation.edit='no'; quotation_item.price=Number(content_cache); updateQuotationItem(quotation_item)">
	                                </div>
	                                <div class="quotation_column6 hideIfNoShow">
	                                  $ {{(quotation_item.price*quotation_item.number).toLocaleString()}}
	                                </div>
	                                <button @click="deleteQuotationItem(quotation_item,quotation_item_category)" class="btn btn-xs btn-default delete_quotation_item"><i class="fa fa-times text-danger"></i></button>
				                      	</Draggable>
			                    		</Container>
			                    		<div class="text-center">
			                    			<button class="btn btn-default btn-xs" @click="createNewQuotationItemToCategory(quotation_item_category)">
			                    				<i class="fa fa-plus"></i>
			                    			</button>
			                    		</div>
			                    	</div>
		                      </Draggable>
		                    </Container>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="6">
                        <div class="text-center">
                          <button class="btn btn-default" @click="createQuotationItemCategory()">新增空白分類</button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="4"></td>
                      <td class="text-right">小計</td>
                      <td class="text-right">$ {{totalPrice.toLocaleString()}}</td>
                    </tr>
                    <tr>
                      <td colspan="4"></td>
                      <td class="text-right">
                        <span class="pointer" v-show="quotation.edit=='no' || quotation.edit!='quotation_information_tax'"  @click="editTextClick('quotation_information_tax',quotation.quotation_information.tax)">
                          <i class="fa fa-pencil-alt"></i> 
                          <span v-if="checkEmpty(quotation.quotation_information.tax)">稅金：無</span>
                          <span v-else>稅金：{{quotation.quotation_information.tax}}%</span>
                        </span>
                        <input ref="quotation_information_tax" class="medium-input" v-show="quotation.edit=='quotation_information_tax'" v-model="content_cache" v-on:blur="quotation.edit='no'; quotation.quotation_information.tax=content_cache; UpdateQuotation()">
                      </td>
                      <td class="text-right">$ {{(totalPriceAfterTax-totalPrice).toLocaleString()}}</td>
                    </tr>
                    <tr>
                      <td colspan="2" class="quotation-color" v-bind:style="{'background-color': quotation['quotation_information']['background_color1'].hex,'color':quotation['quotation_information']['color1'].hex,}">備註</td>
                      <td colspan="2"></td>
                      <td class="quotation-color text-right" v-bind:style="{'background-color': quotation['quotation_information']['background_color1'].hex,'color':quotation['quotation_information']['color1'].hex,}">總計</td>
                      <td class="quotation-color text-right" v-bind:style="{'background-color': quotation['quotation_information']['background_color1'].hex,'color':quotation['quotation_information']['color1'].hex,}">$ {{totalPriceAfterTax.toLocaleString()}}</td>
                    </tr>
                  </tfoot>
                </table>
                <div class="content text-left">
                  <!-- 備註編輯區 -->
                  <div v-show="quotation.edit=='no' || quotation.edit!='quotation_information_note'"  @click="editTextClick('quotation_information_note',quotation.quotation_information.note)" v-if="quotation.quotation_information.note==null || quotation.quotation_information.note==''" class="pointer">
                    <i class="fa fa-pencil-alt"></i> 報價單備註編輯區
                  </div>
                  <div v-show="quotation.edit=='no' || quotation.edit!='quotation_information_note'"   @click="editTextClick('quotation_information_note',quotation.quotation_information.note)" v-else  class="pointer"><pre class="pre-style"><i class="fa fa-pencil-alt"></i> <br>{{quotation.quotation_information.note}}</pre>

                  </div>
                  <textarea v-autosize="quotation.quotation_information.note" ref="quotation_information_note" class="full-input" rows=3 v-show="quotation.edit=='quotation_information_note'" v-model="content_cache" v-on:blur="quotation.edit='no';quotation.edit='no'; quotation.quotation_information.note=content_cache; UpdateQuotation()">{{quotation.quotation_information.note}}</textarea>
                </div>
                <br>
                <br>
                <p class="text-right">客戶簽章：_________________________________________</p>
              </div>
              <div class="quotation-footer">
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Page Container End Here-->
    <aside class="rightbar right-aside-toggle ">
      <div class="rightbar-container products_list_for_quotation">
        <div class="chat-user-toolbar clearfix">
            <div class="chat-user-search">
                <span class="addon-icon"><i class="zmdi zmdi-search"></i></span>
                <input type="text" v-model="keyword" class="form-control" placeholder="關鍵字搜尋服務..">
            </div>
        </div>
        <div class="chat-user-container">
          <div class="products-scroll-box" v-if="products.length > 0">
            <div class="category-box" v-for="product_category,indexPc in orderedProductCategories">
              <h3 class="clearfix" v-if="filterProducts[indexPc].length > 0"><span class="pull-left">{{product_category.name}}</span><span class="pull-right online-counter">{{filterProducts[indexPc].length}} 項</span></h3>
              <ul class="chat-user-list" v-for="product in filterProducts[indexPc]" v-if="product.product_category_id == product_category.id">
                  <li>
                      <div data-trigger="hover" title="Robertoortiz" data-placement="left" @click="createQuotationItemFromProduct(product_category,product)">
                        <span class="chat-avatar"><i class="fa fa-plus"></i></span>
                        <span class="chat-u-info">{{product.name}}<cite>${{product.price}}</cite></span>
                      </div>
                  </li>
              </ul>
            </div>
            <div class="category-box">
              <h3 class="clearfix" v-if="noCategoryProducts[0].length > 0">
              	<span class="pull-left" v-if="product_categories.length > 0" >未分類</span><span  class="pull-left" v-else>所有服務</span><span class="pull-right online-counter">{{noCategoryProducts[0].length}} 項</span>
              </h3>
              <ul class="chat-user-list" v-for="product in noCategoryProducts[0]">
                  <li>
                      <div data-trigger="hover" title="Robertoortiz" data-placement="left">
                        <span class="chat-avatar"><i class="fa fa-plus"></i></span>
                        <span class="chat-u-info">{{product.name}}<cite>${{product.price}}</cite></span>
                      </div>
                  </li>
              </ul>
               <h3 class="clearfix" v-if="searchedProducts.length == 0"><span class="pull-left" >無符合的服務，請重新搜尋，或先到服務管理區建立此服務</span>
                <button class="btn btn-default margin-top-10" @click="GoProducts()">前往服務管理</button>
               </h3>
            </div>
          </div>
          <div class="category-box" v-else>
            <h3 class="clearfix" v-if="searchedProducts.length == 0"><span class="pull-left" >目前無任何可快速新增的服務，強烈建議您到服務管理區，將你的公司服務清單建立，未來將可快速增加報價單項目，大幅節省80%的報價時間唷！</span>
              <button class="btn btn-danger margin-top-10" @click="GoProducts()"><i class="fa fa-flash"></i> 馬上前往服務管理！</button>
            </h3>
          </div>
        </div>
      </div>
    </aside>
    <!--Rightbar End Here-->
    <!-- modal template start-->
    <div v-if="DeleteQuotationItemCategoryModal" @keyup.esc="DeleteQuotationItemCategoryModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="DeleteQuotationItemCategoryModal=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header">
              <div name="header">
                你確定要刪除此分類嗎？
              </div>
              <a href="#" class="btn-close" @click="DeleteQuotationItemCategoryModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms">
              <p>你即將刪除「{{delete_quotation_item_category.name}}」分類以及底下所有項目，此項步驟無法回覆。</p>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-danger" @click="deleteQuotationItemCategory(delete_quotation_item_category)">
                  確定刪除
                </button>
                <button class="btn btn-default" @click="DeleteQuotationItemCategoryModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <!-- modal template start-->
    <div v-if="SettingModal" @keyup.esc="SettingModal=false">
      <div class="modal-mask">
        <div class="modal-wrapper" @click="SettingModal=false">
          <div class="modal-container col-md-6" @click.stop>
            <div class="modal-header text-center" style="display:block">
              <span>報價單編輯器，預設管理</span>
              <a href="#" class="btn-close" @click="SettingModal = false">
                <i class="zmdi zmdi-close"></i>
              </a>
            </div>
            <div class="modal-body j-forms" style="max-height:500px;overflow:scroll">
              <div class="alert alert-info" role="alert">
                在這裡，你可以變更報價單的基本設定，也可儲存為預設值，預設值會在你下次建立一個全新的報價單的時候帶入
              </div>
              <div class="form-group color-picker">
                <label for="exampleInputPassword1">Logo上傳 (建議上傳寬度300px,高度介於50~100px的長型LOGO)</label>
                <dropzone 
                  id="myVueDropzone" 
                  :url="axios.defaults.baseURL + '/quotations/update_company_logo/'+quotation.quotation_token" 
                  :headers=auth_token
                  :maxFileSizeInMB='12'
                  @vdropzone-success="vsuccess"
                  >
                </dropzone>
              </div>
              <div class="form-group">
                <label for="exampleInputEmail1">公司名稱</label>
                <input class="form-control" v-model="quotation.sales_information['company_name']">
              </div>
              <div class="form-group">
                <label for="exampleInputPassword1">標題顏色調整</label>
                <span class="quotation-color pointer" @click="toggleColorPicker()" v-bind:style="{'background-color': quotation['quotation_information']['background_color1'].hex,'color':quotation['quotation_information']['color1'].hex,'padding':'8px',}">這是標題，請點我調整顏色試試看 <i class="fa fa-cog"></i></span>
              </div>
              <div v-if="showColorPicker" class="colorPickerBox card">
                <div class="form-group color-picker">
                  <label for="exampleInputPassword1">標題背景顏色</label>
                  <slider-picker v-model="quotation['quotation_information']['background_color1']" />
                  <material-picker v-model="quotation['quotation_information']['background_color1']" />
                </div>
                <div class="form-group color-picker">
                  <label for="exampleInputPassword1">標題文字顏色</label>
                  <grayscale-picker v-model="quotation['quotation_information']['color1']" />
                </div>
              </div>
              <div class="form-group">
                <label for="exampleInputEmail1">備註</label>
                <textarea v-autosize="quotation.quotation_information.note" rows="3" class="form-control" style="height:auto !important" ref="quotation_information_note" v-model="quotation.quotation_information.note" v-on:blur="UpdateQuotation()">{{quotation.quotation_information.note}}</textarea>
                <small id="emailHelp" class="form-text text-muted">這將會放在報價單最底部</small>
              </div>
            </div>
            <div class="modal-footer j-forms">
              <div name="footer">
                <button class="btn btn-success" @click="syncQuotationAll();saveDefault();SettingModal = false">
                  儲存並設定為預設值
                </button>
                <button class="btn btn-info" @click="syncQuotationAll();SettingModal = false">
                  僅儲存這份報價單
                </button>
                <button class="btn btn-default" @click="SettingModal = false">
                  取消
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal template end-->
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
  </div>
</template>

<script>
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import autocomplete from 'vue2-autocomplete-js'
import draggable from 'vuedraggable'
import { Material,Slider,Grayscale } from 'vue-color'
import Dropzone from 'vue2-dropzone'
import moment from "moment";
import Simplert from 'vue2-simplert'
import { Container, Draggable } from "vue-smooth-dnd";
import { applyDrag, generateItems } from '../../utils/dragHelpers'
import { getArrayItemById, getArrayItem } from '../../utils/commonHelpers'


export default {
  name: 'activities',
  data() {
    return {
      refs: this.$refs,
      keyword: "",
      content_cache: '',
      quotation: {},
      product_categories: [],
      products: [],
      total_price: 0,
      new_item: { name: '', amount: '', price: '', description: ''},
      dragged_data: '',
      DeleteQuotationItemCategoryModal: false,
      delete_quotation_item_category: "",
      updating: false,
      turn_to_pdf: false,
      SettingModal: false,
      showColorPicker: false,
      auth_token: '',
      editable: true,
      temp_item: {},
      temp_category: {},
      dropPlaceholderOptions: {
        className: 'drop-preview',
        animationDuration: '150',
        showOnTop: true
      },
      dropItemPlaceholderOptions: {
        className: 'drop-preview',
        showOnTop: true
      },
    }
  },
  created(){
    this.getProducts();
    this.getProductCategories();
    this.getQuotation(this.$route.params.quotation_token);
    // only use in QuotaionView
    this.hideSideBar();
    this.resetTemp();
  },
  props: ['toggle_aside'],
  components: {
    draggable,
    'material-picker': Material,
    'slider-picker': Slider,
    'grayscale-picker': Grayscale,
    Dropzone,
    Simplert,
    Container, 
    Draggable
  },
  computed: {
    totalPrice: function() {
      var t = 0
      let vm = this
      $.each(this.quotation.quotation_item_categories,function(ic,c){
        $.each(c.quotation_items,function(i,val){
	        t += val.price*val.number
	      })
      })
     
      return t
    },
    totalPriceAfterTax: function() {
      var tax = this.quotation.quotation_information.tax
      if(this.quotation.quotation_information.tax == 0 || this.quotation.quotation_information.tax == ""){
        tax = 0
      }
      return Math.round(this.totalPrice*(100+parseInt(tax))/100)

    },
    orderedProducts: function () {
      //return this.products
      return _.orderBy(this.products, 'order')
    },
    orderedProductCategories: function () {
      //return this.product_categories
      return _.orderBy(this.product_categories, 'order')
    },
    searchedProducts: function() {      
      return this.orderedProducts.filter((product)=>{
        return product.name.match(this.keyword)
      })
    },
    filterProducts: function() { 
      var pc_len = this.orderedProductCategories.length
      var return_products = [];
      const vm = this;
      //將服務分類
      for (var i = 0; i <= pc_len - 1; ++i) {
        return_products[i] = vm.searchedProducts.filter(product => product.product_category_id == vm.orderedProductCategories[i].id)
      }
      return return_products
    },
    noCategoryProducts: function() {
      var return_products = [];
      return_products[0] = this.searchedProducts.filter(product => product.product_category_id == null)
      return return_products
    },
  },
  methods: {
    GoDeal(deal_token) {
      this.$router.push({name: 'deal', params: { deal_token: deal_token } })
    },
    GoProducts() {
      this.$router.push('/products')
    },
    hideSideBar(){
      this.$emit('input', false)
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    getProducts() {
      this.auth_token = { 'Auth-Token': getCookie('auth_token') }
      const vm = this;
      this.axios.get('products')
        .then(function(response) {
          if (response.status == 200 && response['data']['status'] == 'success') {
            vm.products = response['data']['data']['products']
          } else {
            console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    getProductCategories() {
      const vm = this;
      this.axios.get('product_categories')
        .then(function(response) {
          if (response.status == 200 && response['data']['status'] == 'success') {
            vm.product_categories = response['data']['data']['product_categories']
          } else {
            console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    getQuotation(quotation_token) {
      const vm = this;
      this.axios.get('quotations/show', {
          params: {'quotation_token': quotation_token }
        })
        .then(function(response) {
          if (response.status == 200 && response['data']['status'] == 'success') {
            vm.quotation = response['data']['data']['quotation']
          } else {
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
    },
    resetTemp(){
    	this.temp_category = {
    		'id': null,
    		'name': '',
    		'order': 999,
    		'product_id': null,
    		'loading': false,
    		'quotation_items': [],
    	}
    	this.temp_item = {
    		"id":null,
    		"name":'',
    		"quotation_item_category_id": null,
    		"price": 0,
    		'order': 999,
    		"product_id": null,
    		"description": '',
    		'loading': false,
    	}
    },
    editTextClick(n,value){
      var vm = this
      this.quotation.edit=n
      this.content_cache=value
      this.$nextTick(() => {
        if (Array.isArray(vm.$refs[n])){
          vm.$refs[n][0].focus()
        }else{
          vm.$refs[n].focus()
        }
      })
    },
    checkEmpty(v){
      if(v==null || v=='' || v==0){
        return true
      }else
        return false
    },
    createQuotationItemCategory(){
    	let vm = this
    	this.axios.post('quotations/quotation_item_categories', {
        quotation_token: vm.$route.params.quotation_token,
        quotation_item_category: vm.temp_category,
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status'] == 'success') {
          var new_category = response['data']['data']['current_object']
          vm.quotation.quotation_item_categories.push(new_category)
          vm.resetTemp()
        } else {
          vm.$toastr.e(
			      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況！"
			    );
        }
      })
      .catch(function(error) {
        vm.$toastr.e(
		      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況！"
		    );
      });  
    },
    createQuotationItemFromProduct(category,p){
    	let vm = this
    	this.resetTemp()
    	this.temp_item.name = p.name
    	this.temp_item.price = p.price
    	this.temp_item.product_id = p.id
    	this.temp_item.description = p.description

      var resource_category = this.quotation.quotation_item_categories.filter(qc => qc.product_category_id == category.id)

      if(resource_category == ""){
        //如果不存在，建立一個報價分類，才建立服務
        this.temp_category.name = category.name
        this.temp_category.product_category_id = p.product_category_id
        this.temp_category.quotation_items.push(this.temp_item)

				this.axios.post('quotations/quotation_item_categories', {
	        quotation_token: vm.$route.params.quotation_token,
	        quotation_item_category: vm.temp_category,
	      })
	      .then(function(response) {
	        if (response.status == 200 && response['data']['status'] == 'success') {
	          var new_category = response['data']['data']['current_object']
	          vm.quotation.quotation_item_categories.push(new_category)
	         // vm.editColumn('category_name',new_category.id)
	          vm.resetTemp()
	        } else {
	          vm.$toastr.e(
				      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況！"
				    );
	        }
	      })
	      .catch(function(error) {
	        vm.$toastr.e(
			      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況！"
			    );
	      });  
      }else{
        //是一個已經有分類的服務，直接加到該分類
        vm.createNewQuotationItemToCategory(resource_category[0])
      }
    },
    createNewQuotationItemToCategory(category){
      //建立新項目
      const vm = this;
      this.axios.post('quotations/quotation_items', {
        quotation_item: vm.temp_item,
        quotation_item_category_id: category.id,
        quotation_token: vm.quotation.quotation_token
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status'] == 'success') {
          var new_item =  response['data']['data']['current_object']
          category.quotation_items.push(new_item)
          vm.resetTemp()
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    updateQuotationItem(quotation_item){
      console.log('updateQuotationItem')
      quotation_item.description = quotation_item.description.replace(/[\u2028\u2029]+/g,"");
      const vm = this;
      this.axios.put('quotations/quotation_items/'+quotation_item.id, {
        quotation_item: quotation_item,
        quotation_item_category_id: quotation_item.quotation_item_category_id,
        quotation_token: vm.quotation.quotation_token,
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status'] == 'success') {

        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    deleteQuotationItem(quotation_item,quotation_item_category){

      const vm = this;
      var index = quotation_item_category.quotation_items.indexOf(quotation_item)
      quotation_item_category.quotation_items.splice(parseInt(index), 1)

      this.axios.delete('quotations/quotation_items/'+quotation_item.id, {
        params: {
          quotation_token: vm.quotation.quotation_token,
          quotation_item_category_id: quotation_item_category.id,
          quotation_item: quotation_item
        }
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status']== 'success') {

        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });

    },
    checkQuotationItemCategoryBeforeDelete(qic){
      const vm = this;
      var qis = qic.quotation_items;
      console.log(qis.length);
      if(qis.length == 0){
        vm.deleteQuotationItemCategory(qic,"all")
      }else{
        vm.DeleteQuotationItemCategoryModal=true;
      }
    },
    deleteQuotationItemCategory(quotation_item_category){
      
    	let vm = this
    	var index = vm.quotation.quotation_item_categories.indexOf(quotation_item_category)
      vm.quotation.quotation_item_categories.splice(parseInt(index), 1)
      vm.DeleteQuotationItemCategoryModal= false
      this.axios.delete('quotations/quotation_item_categories/'+quotation_item_category.id, {
        params: {
          quotation_token: vm.quotation.quotation_token,
          quotation_item_category: quotation_item_category,
        }
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status']== 'success') {
         
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });

    },   
    UpdateCategory(quotation_item_category){
    	let vm = this
    	this.axios.put('quotations/quotation_item_categories/'+quotation_item_category.id, {
        quotation_item_category: quotation_item_category,
        quotation_token: vm.quotation.quotation_token,
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status'] == 'success') {

        } else {
          vm.$toastr.e(
			      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況"
			    );
        }
      })
      .catch(function(error) {
        vm.$toastr.e(
		      "無法執行這項動作，請重新整理畫面，或稍後再試，也可通知管理員你遇到的錯誤狀況"
		    );
      });
    },
    UpdateQuotation(){
      this.syncQuotationAll()
    },
    syncQuotationAll(){
      //將整個報價單，包含訂單內容、項目、分類、同步資料庫（同步也包含新增、刪除），並且更新回來
      this.updating = true
      const vm = this;
      this.axios.post('quotations/sync_all', {
        quotation_token: vm.$route.params.quotation_token,
        quotation: vm.quotation
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status'] == 'success' ) {
          //暫時不使用
          //vm.getQuotation(vm.$route.params.quotation_token)
          setTimeout(function(){ 
            vm.updating = false
            vm.quotation.updated_at = moment(vm.quotation.updated_at).format()
          }, 500);
        } else {
          console.log(response)
          var obj = {
            isShown: true,
            title: '儲存失敗',
            message: '本次變更儲存失敗，已通報程式人員，請您再嘗試儲存一次，若此狀況持續發生，請稍後再進行編輯報價單。',
            type: 'warning',
            customCloseBtnText: '關閉',
          }
          vm.refs.simplert.openSimplert(obj);

        }
      })
      .catch(function(error) {
        console.log('error:', error)
        var obj = {
          isShown: true,
          title: '儲存失敗',
          message: '本次變更儲存失敗，已通報程式人員，請您再嘗試儲存一次，若此狀況持續發生，請稍後再進行編輯報價單。',
          type: 'warning',
          customCloseBtnText: '關閉',
        }
        vm.refs.simplert.openSimplert(obj);
      });
    },
    saveDefault(){
      var vm = this
      console.log('saveDefault')
      setTimeout(function(){ 
        vm.axios.post('quotations/save_default', {
          quotation_token: vm.$route.params.quotation_token,
          quotation: vm.quotation
        })
        .then(function(response) {
          if (response.status == 200 && response['data']['status'] == 'success') {
            //暫時使用
          } else {
            console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
      }, 1500);
    },
    vsuccess(file, response) {
      this.quotation.logo = response["data"]
      // window.toastr.success('', 'Event : vdropzone-success')
    },
    changePriceDefault(){
      var vm = this
      if(vm.content_cache == 0){
        vm.content_cache = ""
      }
    },
    toggleColorPicker(){
      var vm = this 
      if(vm.showColorPicker == false){
        vm.showColorPicker = true
      }else{
        vm.showColorPicker = false
      }
    },
    turnToPdf(){
      this.syncQuotationAll()
      this.turn_to_pdf = true
      const vm = this;
      setTimeout(function(){ 
        vm.axios.post('quotations/turn_to_pdf', {
          quotation_token: vm.$route.params.quotation_token
        })
        .then(function(response) {
          if (response.status == 200 && response['data']['status'] == 'success') {
            //暫時使用
            setTimeout(function(){ 
              window.open(vm.axios.defaults.baseURL+"/pdf_generators/quotation.pdf?quotation_token="+vm.$route.params.quotation_token)
              vm.turn_to_pdf = false
              vm.GoDeal(vm.quotation.deal_token)
            }, 1500);
          } else {
            console.log(response)
          }
        })
        .catch(function(error) {
          console.log('error:', error)
        });
      }, 1500);
    },
    // smooth dnd function
    onListDrop (dropResult) {
      let vm = this
      vm.quotation.quotation_item_categories = applyDrag(vm.quotation.quotation_item_categories, dropResult)
      this.axios.post('quotations/quotation_item_categories/update_order', {
        quotation_item_categories: vm.quotation.quotation_item_categories,
        quotation_token: vm.quotation.quotation_token,
      })
      .then(function(response) {
        if (response.status == 200 && response['data']['status'] == 'success' ) {
          
        } else {
          console.log(response)
        }
      })
      .catch(function(error) {
        console.log('error:', error)
      });
    },
    onItemDrop(CategoryId, dropResult) {
      let vm = this
      if (dropResult.removedIndex !== null || dropResult.addedIndex !== null) {
        const category = vm.quotation.quotation_item_categories.filter(p => p.id === CategoryId)[0]
        const categoryIndex = vm.quotation.quotation_item_categories.indexOf(category)
        const new_category = Object.assign({}, category)
        new_category.quotation_items = applyDrag(new_category.quotation_items, dropResult)
        vm.quotation.quotation_item_categories.splice(categoryIndex, 1, new_category)

        console.log('new_category',new_category)

        vm.axios.post('quotations/quotation_items/update_order', {
        	quotation_items: new_category.quotation_items,
	        quotation_item_category_id: new_category.id,
        	quotation_token: vm.quotation.quotation_token,
	      })
	      .then(function(response) {
	        if (response.status == 200 && response['data']['status'] == 'success') {
	          // vm.$emit("update-project", project);
	        } else {
	          console.log(response)
	        }
	      })
	      .catch(function(error) {
	        console.log('error:', error)
	      });
      }
    },
    isPresent(obj) {
		  return Object.keys(obj).length != 0;
		},
    getCardPayload (columnId) {
      return index => {
        return this.quotation.quotation_item_categories.filter(p => p.id === columnId)[0].quotation_items[index]
      }
    },
  }
}
</script>


// WEBPACK FOOTER //
// QuotationView.vue?78ed2dd5